import React from 'react';
import { Reveal } from './Reveal';
import { CountUp } from './CountUp';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const About: React.FC = () => {
  const { about } = useContent();

  return (
    <section id="about" className="hello-grid">
      <Reveal className="hello-card glass">
        <div className="eyebrow">{about.eyebrow}</div>
        <h2 className="display-h2" dangerouslySetInnerHTML={{ __html: about.headingHtml }} />
        <p className="body-text">{about.body}</p>
        <div className="stat-block">
          <CountUp className="stat-num" value={about.statValue} suffix={about.statSuffix} />
          <span className="stat-label">{about.statLabel}</span>
        </div>
        <p className="small">{about.small}</p>
      </Reveal>

      <Reveal delay={120} className="exp-card glass-soft">
        <h4 className="display-h4">{about.skillsTitle}</h4>
        <ul className="exp-list">
          {about.skills.map((s) => (
            <li key={s} dangerouslySetInnerHTML={{ __html: s }} />
          ))}
        </ul>
      </Reveal>
    </section>
  );
};
